$(function () {
    // Page: Managed Kubernetes

    let form = $('#contact-form')
    let formElements = $('form input, form textarea, form select')
    let submitFormElement = $('.submit-form')
    let processingText = submitFormElement.data('processing')
    let recaptchaLoaded = false

    form.validate({
        ignore: [],
        rules: {
            names: {
                required: true
            },
            company: {
                required: true
            },
            email: {
                required: true,
                email: true
            },
            phone: {
                required: true,
                number: true
            },
            message: {
                required: true
            }
        },
        messages: {
            names: {
                required: window.validationMessages['names.required']
            },
            company: {
                required: window.validationMessages['company.required']
            },
            email: {
                required: window.validationMessages['email.required'],
                email: window.validationMessages['email.email']
            },
            phone: {
                required: window.validationMessages['phone.required'],
                number: window.validationMessages['phone.number']
            },
            message: {
                required: window.validationMessages['text.required']
            }
        },
        highlight: function (element) {
            $(element).parent().addClass('group-error')
        },
        unhighlight: function (element) {
            $(element).parent().removeClass('group-error')
        }
    })

    formElements.on('focus', function () {
        if (recaptchaLoaded !== true) {
            let head = document.getElementsByTagName('head')[0]
            let recaptchaScript = document.createElement('script')

            recaptchaScript.type = 'text/javascript'
            recaptchaScript.src = 'https://www.google.com/recaptcha/api.js'
            head.appendChild(recaptchaScript)

            recaptchaLoaded = true
        }
    })

    window.shouldNotSubmit = true
    window.formToSubmit = null

    form.on('submit', function (e) {
        if (window.shouldNotSubmit && $(this).valid()) {
            e.preventDefault()

            submitFormElement.prop('disabled', true).val(processingText)

            window.formToSubmit = $(this)
            grecaptcha.execute()

            const url = window.location.href
            const page = url.substring(url.lastIndexOf('/') + 1)

            gtm('contact_form', {page: page, type: 'managed_kubernetes'})

            console.log('Form submitted successfully!')
        }
    })

    window.insertIntoForm = function () {
        let recaptchaResponse = grecaptcha.getResponse()
        form.append('<input type="hidden" name="g-recaptcha-response" value="' + recaptchaResponse + '" />')
        window.shouldNotSubmit = false

        submitFormElement.prop('disabled', false)
        submitFormElement.trigger('click').prop('disabled', true)
    }
})
